import { ArrowUpRight, Code2, Network, Wrench } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { scrollToId } from "../hooks/useLenis";

const SOFT_IMG = "https://images.unsplash.com/photo-1666101041092-468eb2818c87?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

const SMALL = [
  { n: "02", icon: Network, title: "Infrastructure & Réseau", text: "Câblage, Wi-Fi professionnel, serveurs, sécurité : une infrastructure fiable pour vos équipes." },
  { n: "03", icon: Wrench, title: "Maintenance & Support", text: "Contrats de maintenance, dépannage rapide, remplacement de pièces et assistance à distance." },
];

const MODULES = ["Gestion de stock", "Facturation & devis", "Comptabilité", "Paie & RH", "Point de vente", "Tableaux de bord"];

export const Services = () => (
  <section id="services" data-testid="services-section" className="bg-white py-20 lg:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
      <SectionHead eyebrow="02 — Prestations" title="Un logiciel de gestion qui épouse votre métier." text="Au-delà du matériel, nous concevons des logiciels de gestion sur mesure : conçus avec vous, déployés chez vous, maintenus par nous." />

      <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-12 lg:gap-8">
        <Reveal className="group relative overflow-hidden bg-navy text-white md:col-span-7" data-testid="service-card-logiciel">
          <div className="grain absolute inset-0" />
          <img src={SOFT_IMG} alt="Développement logiciel" className="absolute inset-0 h-full w-full object-cover opacity-30 transition-[transform,opacity] duration-1000 group-hover:scale-105 group-hover:opacity-40" />
          <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/80 to-navy/30" />
          <div className="relative z-10 flex h-full min-h-[520px] flex-col justify-between p-8 lg:p-12">
            <div className="flex items-start justify-between">
              <span className="font-serif text-5xl italic text-gold">01</span>
              <Code2 className="h-7 w-7 text-gold" />
            </div>
            <div>
              <p className="eyebrow text-gold">Prestation phare</p>
              <h3 className="mt-3 font-display text-2xl font-bold sm:text-3xl">Développement de logiciel de gestion</h3>
              <p className="mt-4 max-w-md text-sm leading-relaxed text-white/70">Boutique, pharmacie, école, cabinet, PME : nous analysons vos processus et livrons un outil simple, rapide et adapté, avec formation de vos équipes.</p>
              <ul className="mt-6 flex flex-wrap gap-2">
                {MODULES.map((m) => <li key={m} className="border border-white/20 px-3 py-1.5 font-mono text-[11px] uppercase tracking-wider text-white/80">{m}</li>)}
              </ul>
              <button data-testid="service-cta-devis" onClick={() => scrollToId("contact")} className="btn-white mt-8 group/btn">
                Demander un devis <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover/btn:-translate-y-0.5 group-hover/btn:translate-x-0.5" />
              </button>
            </div>
          </div>
        </Reveal>

        <div className="grid gap-6 md:col-span-5 lg:gap-8">
          {SMALL.map((s, i) => (
            <Reveal key={s.n} delay={0.1 * (i + 1)} className="group flex flex-col justify-between border border-navy/10 bg-ice p-8 transition-colors duration-500 hover:border-royal" data-testid={`service-card-${s.n}`}>
              <div className="flex items-start justify-between">
                <span className="font-serif text-4xl italic text-royal">{s.n}</span>
                <s.icon className="h-6 w-6 text-navy transition-colors duration-300 group-hover:text-royal" />
              </div>
              <div className="mt-10">
                <h3 className="font-display text-xl font-semibold text-navy">{s.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-600">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
